module.exports = __webpack_public_path__ + "img/radios.4fe1eb31.gif";